export const Bio = {
  name: 'Vignesh Pamu',
  roles: [
    'Full Stack Developer',
    'UI/UX Designer',
    'Programmer',
    'Problem-Solver',
  ],
  description:
    'I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.',
  github: 'https://github.com/vigneshpamu',
  resume:
    'https://drive.google.com/file/d/1HhQhFmq-MTr5ywOXgUnn9OopIwBoAs1n/view?usp=sharing',
  linkedin: 'https://www.linkedin.com/in/vignesh-pamu/',
  twitter: 'https://twitter.com/vigneshstwt',
  insta: 'https://www.instagram.com/rishav_chanda/',
  facebook: 'https://www.facebook.com/rishav.chanda.165/',
}

export const skills = [
  {
    title: 'Frontend',
    skills: [
      {
        name: 'React Js',
        image:
          'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K',
      },
      {
        name: 'Redux',
        image:
          'https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg',
      },
      {
        name: 'Next Js',
        image:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=',
      },
      {
        name: 'HTML',
        image: 'https://www.w3.org/html/logo/badge/html5-badge-h-solo.png',
      },
      {
        name: 'CSS',
        image:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png',
      },
      {
        name: 'JavaScript',
        image:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png',
      },
      {
        name: 'Bootstrap',
        image:
          'https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png',
      },
      {
        name: 'Material UI',
        image:
          'data:image/png;base64,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',
      },
      // {
      //   name: 'Flutter',
      //   image:
      //     'https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png',
      // },
    ],
  },
  {
    title: 'Backend',
    skills: [
      {
        name: 'Node Js',
        image: 'https://nodejs.org/static/images/logo.svg',
      },
      {
        name: 'Express Js',
        image: 'https://img.icons8.com/ios/50/express-js.png',
      },
      {
        name: 'Graph Ql',
        image: 'https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg',
      },
      {
        name: 'Python',
        image:
          'https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg',
      },
      {
        name: 'MySQL',
        image:
          'https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg',
      },
      {
        name: 'MongoDB',
        image:
          'https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg',
      },
      {
        name: 'Firebase',
        image: 'https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg',
      },
    ],
  },
  {
    title: 'Android',
    skills: [
      {
        name: 'Java',
        image:
          'https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg',
      },
      {
        name: 'React Native',
        image:
          'https://img.icons8.com/external-others-amoghdesign/24/external-react-native-soleicons-fill-vol-1-others-amoghdesign.png',
      },
    ],
  },
  {
    title: 'Others',
    skills: [
      {
        name: 'Git',
        image:
          'https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667',
      },
      {
        name: 'GitHub',
        image:
          'https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png',
      },
      {
        name: 'Vercel',
        image:
          'https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg',
      },
      {
        name: 'Netlify',
        image:
          'https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png',
      },
      {
        name: 'VS Code',
        image:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519',
      },
      {
        name: 'Postman',
        image:
          'https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667',
      },
      {
        name: 'Adobe XD',
        image:
          'https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667',
      },
      {
        name: 'Figma',
        image:
          'https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667',
      },
    ],
  },
]

export const experiences = [
  {
    id: 0,
    img: 'https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543',
    role: 'Full Stack Developer',
    company: 'MBS Solution Pvt. Ltd.',
    date: 'Oct 2023 -  Present',
    desc: 'Working on a Full Stack Web App, using Express Js',
    skills: [
      'Node Js',
      'Express Js',
      'Laravel',
      'PHP',
      'JavaScript',
      'TypeScript',
      'Next Js',
      'React Js',
    ],
    // doc: 'https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ',
  },
  // {
  //   id: 0,
  //   img: 'https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad',
  //   role: 'Frontend Engineer Intern',
  //   company: 'Neurobit',
  //   date: 'June 2023 - Present',
  //   desc: 'Working on the frontend of the web application using ReactJS, Redux, and Material UI.',
  //   skills: [
  //     'ReactJS',
  //     'Redux',
  //     'NodeJs',
  //     'Material UI',
  //     'HTML',
  //     'CSS',
  //     'JavaScript',
  //   ],
  //   doc: 'https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730',
  // },
  // {
  //   id: 1,
  //   img: 'https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543',
  //   role: 'Fullstack Externship',
  //   company: 'Flipr',
  //   date: 'June 2023 - July 2023',
  //   desc: 'Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.',
  //   skills: [
  //     'ReactJS',
  //     'Redux',
  //     'NodeJs',
  //     'Material UI',
  //     'HTML',
  //     'CSS',
  //     'JavaScript',
  //     'Docker',
  //     'AWS',
  //     'MongoDB',
  //   ],
  // },
  // {
  //   id: 2,
  //   img: 'https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035',
  //   role: 'Open Source Contributor ',
  //   company: 'GirlScript Summer of Code',
  //   date: 'May 2023 - Present',
  //   desc: 'Contributing to different open-source projects and learn from industry experts',
  //   doc: 'https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc',
  // },
  // {
  //   id: 3,
  //   img: 'https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70',
  //   role: 'Android Developer',
  //   company: 'DSC KIIT',
  //   date: 'Nov2021 - Present',
  //   desc: 'As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.',
  //   skills: [
  //     'Leadership',
  //     'Mobile Application Development',
  //     'Kotlin',
  //     'XML',
  //     'Figma',
  //   ],
  // },
  // {
  //   id: 4,
  //   img: 'https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d',
  //   role: 'Android Developer Intern',
  //   company: 'Rudraksha Welffare Foundation',
  //   date: 'June 2021 - Oct 2021',
  //   desc: "As an Android Developer Intern at Rudraksha Welfare Foundation from June 2021 to October 2021, I gained valuable hands-on experience in application development. During my tenure, I contributed to the development of the application's back-end cloud functions using Firebase and implemented a front-end with the MVVM structure, which was designed using Figma. I also added a one-to-one video call feature, conceptualized new features, and optimized app performance. This internship helped me enhance my skills in Android development and gave me an opportunity to work in a collaborative team environment.",
  //   skills: [
  //     'Android',
  //     'Java',
  //     'Kotlin',
  //     'XML',
  //     'Node Js',
  //     'Cloud Firestore',
  //     'Firebase',
  //     'Figma',
  //   ],
  //   doc: 'https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245',
  // },
]

export const education = [
  {
    id: 0,
    img: 'https://res.cloudinary.com/dxpifkq8x/image/upload/v1696680335/lp08cbh5fd7qatwyxxxi.jpg',
    school: 'SIES College of Commerece and Economics',
    date: 'June 2023 - Sep 2025',
    grade: '8.71 CGPA',
    desc: "I am currently pursuing a Bachelor's degree in Information Technology at SIES College of Commerece and Economics, Mumbai. I have completed 4 semesters and have a CGPA of 9.5. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: 'Bachelor of Science in Information Technology (Bsc. IT)',
  },
  {
    id: 1,
    img: 'https://res.cloudinary.com/dxpifkq8x/image/upload/v1696680227/aq1cejsthiuybirg63jt.png',
    school: 'R.A. Podar College of Commerece and Economics, Mumbai',
    date: 'Apr 2020 - Apr 2022',
    grade: '82.40%',
    desc: 'I completed my class 12 high school education at R.A. Podar College of Commerece and Economics, Mumbai, where I studied German',
    degree: 'HSC(XII), Commerece with German',
  },
  {
    id: 2,
    img: 'https://res.cloudinary.com/dxpifkq8x/image/upload/v1696680126/legbsmugmqj1pq22vmoa.avif',
    school: 'Michael High School, Mumbai',
    date: 'Apr 2018 - Apr 2020',
    grade: '89.20%',
    desc: 'I completed my class 10 education at Michael High School, Mumbai',
    degree: 'SSC(X), Science with Computer',
  },
]

export const projects = [
  {
    id: 0,
    title: 'ClipCloud',
    date: 'Apr 2023 - May 2023',
    description:
      'ClipCloud a web application that allows users to search for, play, and pause their favorite videos on demand. Made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.',
    image:
      'https://res.cloudinary.com/dxpifkq8x/image/upload/v1696680913/mwwpk9dcryrr8zirdbxp.png',
    tags: ['React Js', 'Material UI', 'Redux'],
    category: 'web app',
    github: 'https://github.com/vigneshpamu/clip-cloud',
    webapp: 'https://clipcloud.netlify.app/',
  },
  {
    id: 9,
    title: 'Property Pal',
    date: 'Jun 2023 - Jul 2023',
    description:
      "Property Pal is a web application designed to Add, Read, Update, and Delete listings. It provides a user-friendly interface for sellers to keep track of their listings' daily work activities and empowers employees to log their listings efficiently. ",
    image:
      'https://res.cloudinary.com/dxpifkq8x/image/upload/v1696680656/od8d5ooqcwjl6x0phjet.png',
    tags: [
      'Express Js',
      'Firebase',
      'Google OAuth',
      'Eslint',
      'React Js',
      'MongoDb',
      'Node Js',
      'Express Js',
      'Redux',
    ],
    category: 'web app',
    github: 'https://github.com/vigneshpamu/mern-estate-final',
    webapp: 'https://mern-estate-0ee5.onrender.com/',
  },
  {
    id: 1,
    title: 'Sweatpedia',
    date: 'Oct 2022 - Present',
    description:
      "Sweatpedia is your ultimate fitness companion. Our website offers a comprehensive guide to exercises targeting every muscle group, ensuring you never miss a beat in your fitness journey. Explore a vast library of workouts, discover related exercises to keep your routine fresh, and get inspired with handpicked YouTube video recommendations. Whether you're a seasoned gym-goer or just starting out, Sweatpedia is here to help you sculpt your body and achieve your fitness goals with ease and expertise.",
    image:
      'https://res.cloudinary.com/dxpifkq8x/image/upload/v1696681382/rkmdnqnvdlpzmrknhhbw.png',
    tags: ['React Js', 'Material UI', 'Redux'],
    category: 'web app',
    github: 'https://github.com/vigneshpamu/sweatpedia-react',
    webapp: 'https://sweatpedia.netlify.app/',
  },
  // {
  //   id: 2,
  //   title: 'Brain Tumor Detection',
  //   date: 'Jan 2023 - Mar 2023',
  //   description:
  //     "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
  //   image:
  //     'https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png',
  //   tags: ['Python', 'Keras', 'TensorFlow', 'VGG16', 'Pickle', 'React'],
  //   category: 'machine learning',
  //   github: 'https://github.com/rishavchanda/Brain-Tumor-Detection',
  //   webapp: 'https://brain-tumor.netlify.app/',
  //   member: [
  //     {
  //       name: 'Vignesh Pamu',
  //       img: 'https://avatars.githubusercontent.com/u/64485885?v=4',
  //       linkedin: 'https://www.linkedin.com/in/rishav-chanda-b89a791b3/',
  //       github: 'https://github.com/rishavchanda/',
  //     },
  //     {
  //       name: 'Upasana Chaudhuri',
  //       img: 'https://avatars.githubusercontent.com/u/100614635?v=4',
  //       linkedin: 'https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/',
  //       github: 'https://github.com/upasana0710',
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   title: 'Buckoid',
  //   date: 'Dec 2021 - Apr 2022',
  //   description:
  //     'App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.',
  //   image:
  //     'https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435',
  //   tags: ['Kotlin', 'MVVM', 'Room Database', 'Google Drive Cloud API'],
  //   category: 'android app',
  //   github: 'https://github.com/rishavchanda/Buckoid-Android-App',
  //   webapp: 'https://play.google.com/store/apps/details?id=com.rishav.buckoid',
  // },
  // {
  //   id: 10,
  //   title: 'Job Finding App',
  //   date: 'Jun 2023 - Jul 2023',
  //   description:
  //     'A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.',
  //   image:
  //     'https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png',
  //   tags: ['React Native', 'JavaScript', 'Axios'],
  //   category: 'android app',
  //   github: 'https://github.com/rishavchanda/Job-finder-App',
  //   webapp: 'https://github.com/rishavchanda/Job-finder-App',
  // },
  // {
  //   id: 4,
  //   title: 'Whatsapp Clone',
  //   date: 'Jul 2021',
  //   description:
  //     'A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.',
  //   image:
  //     'https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89',
  //   tags: ['React Js', 'Firebase', 'Firestore', 'Node JS'],
  //   category: 'web app',
  //   github: 'https://github.com/rishavchanda/Whatsapp-Clone-React-Js',
  //   webapp: 'https://whatsapp-clone-rishav.web.app',
  // },
  // {
  //   id: 5,
  //   title: 'Todo Web App',
  //   date: 'Jun 2021',
  //   description:
  //     ' A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.',
  //   image:
  //     'https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633',
  //   tags: ['React Js', 'Local Storage', 'AWS Auth', 'Node JS'],
  //   category: 'web app',
  //   github: 'https://github.com/rishavchanda/Todo-Web-App',
  //   webapp: 'https://rishav-react-todo.netlify.app/',
  // },
  // {
  //   id: 6,
  //   title: 'Breaking Bad',
  //   date: 'Jun 2021',
  //   description:
  //     'A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.',
  //   image:
  //     'https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263',
  //   tags: ['React Js', 'API', 'Axios', 'Node JS'],
  //   category: 'web app',
  //   github: 'https://github.com/rishavchanda/Breaking-Bad',
  //   webapp: 'https://breaking-bad-webapp.netlify.app',
  // },
  // {
  //   id: 7,
  //   title: 'Quiz App',
  //   date: 'Dec 2020 - Jan 2021',
  //   description:
  //     'A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.',
  //   image:
  //     'https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif',
  //   tags: ['Java', 'Android Studio', 'Firebase', 'Google Auth'],
  //   category: 'android app',
  //   github: 'https://github.com/rishavchanda/Quiz-Earn',
  //   webapp: 'https://github.com/rishavchanda/Quiz-Earn',
  // },
  // {
  //   id: 8,
  //   title: 'Face Recognition',
  //   date: 'Jan 2021',
  //   description:
  //     'A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.',
  //   image:
  //     'https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636',
  //   tags: ['Python', 'Keras', 'TensorFlow', 'VGG16', 'Pickle', 'React'],
  //   category: 'machine learning',
  //   github: 'https://github.com/rishavchanda/Face-Recodnition-AI-with-Python',
  //   webapp: 'https://github.com/rishavchanda/Face-Recodnition-AI-with-Python',
  // },
]

export const TimeLineData = []
